// extracted by mini-css-extract-plugin
export default {"container":"Qu5Ne"};